import {
  GET_CONTACT_US_SUBCATEGORIES_REQUEST,
  GET_CONTACT_US_SUBCATEGORIES_SUCCESS,
  GET_CONTACT_US_SUBCATEGORIES_FAILURE,
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTACT_US_SUBCATEGORIES_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_CONTACT_US_SUBCATEGORIES_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_CONTACT_US_SUBCATEGORIES_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
